<!-- <div class="container" [class]="classHeader">
  <div
    class="title-container"
    (click)="toggleContentContainer()"
    [class.active]="isContentContainerActive"
  >
    <i *ngIf="isEmptyEventName" class="fas fa-user-edit"></i>
    <div *ngIf="!isEmptyEventName" class="image-container">
      <img
        [src]="icon"
        [alt]="'Imagen del evento ' + eventName"
        width="30"
        decoding="async"
        loading="lazy"
      />
    </div>
    <span>{{ titleCard }}</span>
  </div>
  <div *ngIf="isContentContainerActive" class="content-container">
    <ng-content></ng-content>
  </div>
</div> -->

<div class="card" [id]="idCard">
  <ng-content></ng-content>
</div>
